import { useMemo, useState, useCallback } from 'react';
import { CommonHeadingTxt } from '../Text/Text';
import AdvancedTable from '../AdvancedTable';
import NotesModal from '../../pages/bookings/appointment-booking/NotesModal';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { getColumns } from '../../pages/bookings/appointment-booking/columns';

const AppointmentList = ({ appointments }) => {
  // Notes modal state
  const [notesModalVisible, setNotesModalVisible] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const location = useLocation();
  const params = queryString.parse(location.search);
  // Handle notes click
  const handleNotesClick = useCallback(
    row => {
      setSelectedAppointment(row);
      setNotesModalVisible(true);
    },
    []
  );

  // Handle notes modal close
  const handleNotesModalClose = useCallback(() => {
    setNotesModalVisible(false);
    setSelectedAppointment(null);
  }, []);

  // Handle notes update success
  const handleNotesUpdate = useCallback(
    (updatedNotes) => {
      handleNotesModalClose();
      // Refresh the table to show updated notes
      window.location.reload();
    },
    [handleNotesModalClose]
  );

  // Memoize columns
  const columns = useMemo(
    () => getColumns(params, true, handleNotesClick),
    [params?.page, params?.perPage, true, handleNotesClick]
  );

  // Fetch data function
  const fetchAppointments = useMemo(() => {
    return async ({ page, perPage, sortField, sortOrder, search, ...filters }) => {
      const start = (page - 1) * perPage;
      const end = start + perPage;
      const data = appointments || [];
      return {
        data: data.slice(start, end),
        total: data.length,
      };
    };
  }, [appointments]);

  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3 gap-2">
          <CommonHeadingTxt Text="Today's Appointment List" />
        </div>
        <AdvancedTable
          key={`appointments-dashboard-table`}
          resource="appointments"
          columns={columns}
          fetchData={fetchAppointments}
          enableSearch={false}
          enableExport={false}
          enableSummary={false}
          enableDensity={false}
          enableToolBar={true}
          defaultPageSize={10}
          enableHorizontalScrollFeature={true}
          enableHorizontalScroll={false}
          tableId="appointments-dashboard-table"
          // customActions={customActions}
          stickyHeader
          striped
          highlightOnHover
        />
      </div>

      {/* Notes Modal */}
      <NotesModal
        visible={notesModalVisible}
        onCancel={handleNotesModalClose}
        appointmentId={selectedAppointment?._id}
        currentNotes={selectedAppointment?.notes}
        onSuccess={handleNotesUpdate}
      />
    </div>
  );
};

export default AppointmentList;
